import React, { useEffect, useState } from "react";
import ClientData1 from "../../Forms/ClientData1";
import InvoiceData from "../../Forms/InvoiceData";
import useTitle from "hooks/useTitle";
import { Paper, makeStyles } from "@material-ui/core";
import { useStylesGlobal } from "configurations/styles/theme";
import { clearVoucherToDuplicate } from "redux/actions/authorizedVouchersAction";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import {
  clearDuplicateVoucher,
  fetchDuplicateVoucher,
} from "redux/actions/duplicateVoucherAction";

import {
  Card,
  CardContent,
  Typography,
  Button,
  Box,
} from "@material-ui/core";
import ErrorOutlineIcon from "@material-ui/icons/ErrorOutline";


const useStyles = makeStyles(() => ({
  root: {
    paddingTop: "30px",
    flexGrow: 1,
    paddingLeft: "3%",
    paddingRight: "3%",
    marginBottom: "5%",
  },
}));

const Invoice = ({ iDoc }) => {
  const dispatch = useDispatch();
  const classesView = useStyles();
  const classesGlobales = useStylesGlobal();
  const [idAsgCliente, setIdAsgCliente] = useState({});
  const [consumidorFinal, setConsumidorFinal] = useState({
    id: null,
    nombre: null,
  });
  const voucherToDuplicate = useSelector(
    (state) => state.authorizedVouchers.voucherToDuplicate,
  );
  const [foundClient, setFoundClient] = useState({});
  const [options, setOptions] = React.useState([]);
  const { duplicateVoucher, loading, error } = useSelector(
    (state) => state.duplicateVouchers,
  );
  useTitle({ title: "Factura" });

  useEffect(() => {
    if (!voucherToDuplicate) return;
    dispatch(fetchDuplicateVoucher(voucherToDuplicate));
    dispatch(clearVoucherToDuplicate());
  }, []);

  useEffect(() => {
    return () => {
      dispatch(clearDuplicateVoucher());
    };
  }, [dispatch]);

  if (loading) return <div>Cargando...</div>;
  if (error)
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        minHeight="60vh"
      >
        <Card
          elevation={6}
          style={{
            maxWidth: 500,
            width: "100%",
            textAlign: "center",
            padding: "20px",
          }}
        >
          <CardContent>
            <ErrorOutlineIcon
              style={{ fontSize: 50, color: "#d32f2f", marginBottom: 10 }}
            />

            <Typography
              variant="h6"
              style={{ fontWeight: 600, marginBottom: 15 }}
            >
              No fue posible duplicar la factura
            </Typography>

            <Typography
              variant="body2"
              color="textSecondary"
              style={{ marginBottom: 20 }}
            >
              Verifique que los clientes y productos estén registrados y activos
              en el sistema antes de intentar nuevamente.
            </Typography>

            <Button
              variant="contained"
              color="secondary"
              onClick={() => dispatch(clearDuplicateVoucher())}
            >
              Volver
            </Button>
          </CardContent>
        </Card>
      </Box>
    );
  var detalles = null;
  var productos = null;
  var cliente = null;
  var clientType = null;
  var invoiceDataGeneral = null;
  var pedidoComercial = null;
  var pagoPlazo = null;
  var formaPago = null;
  
  if (duplicateVoucher) {
    detalles = duplicateVoucher.productos.map((prod) => prod.detalle);
    productos = duplicateVoucher.productos.map(({ detalle, ...rest }) => rest);
    cliente = duplicateVoucher.datosCliente;
    if (cliente.idAsignacionEmpresaCliente === 0) {
      clientType = "F";
    } else {
      clientType = "D";
    }
    invoiceDataGeneral = duplicateVoucher.invoiceDataGeneral;
    pedidoComercial = duplicateVoucher.pedidoComercialFacturaDto;
    pagoPlazo = duplicateVoucher.pagoPlazoDto;
    formaPago = duplicateVoucher.formaPagoDto;
  }

  return (
    <div className={classesView.root}>
      <Paper className={classesGlobales.paperHeader}>
        <h5 className={classesGlobales.titleHeader}>
          Emisión de
          {iDoc.CODIGO === "FOP" ? " Factura de Operación Interna" : null}
          {iDoc.CODIGO === "FIM" ? " Factura de Importación" : null}
          {iDoc.CODIGO === "FEX" ? " Factura de Exportación" : null}
          {iDoc.CODIGO === "FZF" ? " Factura de Zona Franca" : null}
          {iDoc.CODIGO === "NDG" ? " Nota de Débito Genérica" : null}
          {iDoc.CODIGO === "NDR"
            ? " Nota de Débito Referente a Una o Varias FE"
            : null}
          {iDoc.CODIGO === "NCG" ? " Nota de Crédito Genérica" : null}
          {iDoc.CODIGO === "NCR"
            ? " Nota de Crédito Referente a Una o Varias FE"
            : null}
          {iDoc.CODIGO === "REE" ? " Reembolso" : null}
          {iDoc.CODIGO === "FOE" ? " Factura de Operación Extranjera" : null}
        </h5>
      </Paper>
      <ClientData1
        setIdAsgCliente={setIdAsgCliente}
        setConsumidorFinal={setConsumidorFinal}
        consumidorFinal={consumidorFinal}
        setFoundClient={setFoundClient}
        foundClient={foundClient}
        setOptions={setOptions}
        options={options}
        iDoc={iDoc}
        initialClient={cliente}
        clientType={clientType}
      />
      <InvoiceData
        initialInvoiceDataGeneral={invoiceDataGeneral}
        initialProductsDetalle={productos}
        initialDetalles={detalles}
        inicialPagos={formaPago}
        initialInformacionPagos={pagoPlazo}
        initialInformacionComercial={pedidoComercial}
        setIdAsgCliente={setIdAsgCliente}
        idAsgCliente={idAsgCliente}
        consumidorFinal={consumidorFinal}
        setFoundClient={setFoundClient}
        setOptions={setOptions}
        iDoc={iDoc}
      />
    </div>
  );
};

export default Invoice;
